export default "__VITE_ASSET__bb2eb77c__"